<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Tipologie</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuova tipologia</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" @click="apriDialog(item)" title="Modifica">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="elimina(item)" title="Elimina">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500" :fullscreen="isMobile">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica tipologia' : 'Nuova tipologia' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <v-text-field v-model="form.codice" label="Codice" :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model="form.descrizione" label="Descrizione"
                            :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model.number="form.progOrdinamento" type="number" label="Ordine" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="salvando" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "TipologiePage",

    data() {
        return {
            dialog: false,
            salvando: false,
            form: this.formVuoto(),
            headers: [
                { title: "Codice", key: "codice" },
                { title: "Descrizione", key: "descrizione" },
                { title: "Ordine", key: "progOrdinamento" },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        lista() {
            return this.$store.getters["tipologie/lista"];
        },
    },

    mounted() {
        this.$store.dispatch("tipologie/carica");
    },

    methods: {
        formVuoto() {
            return { id: null, codice: "", descrizione: "", progOrdinamento: 0 };
        },

        apriDialog(item) {
            this.form = item ? { ...item } : this.formVuoto();
            this.dialog = true;
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;
            this.salvando = true;
            try {
                const { id, ...dati } = this.form;
                if (id) {
                    await this.$store.dispatch("tipologie/aggiorna", { id, dati });
                } else {
                    await this.$store.dispatch("tipologie/crea", dati);
                }
                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
            this.salvando = false;
        },

        async elimina(item) {
            try {
                await this.$store.dispatch("tipologie/elimina", item.id);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
